import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'izivia-back-button',
    templateUrl: './iziviaBackButton.component.html',
    styleUrls: ['./iziviaBackButton.component.scss']
})
export class IziviaBackButtonComponent implements OnInit {
    /**
     * URL when there is no history (example: '/login')
     *
     * If not specified it will take current router url (needed to display back button in modal)
     */
    @Input() defaultHref: string;
    @Input() disabled: boolean;
    @Input() icon: string;
    /**
     * Reverse icon color with background color when true
     */
    @Input() reverseColors: boolean;

    constructor(private readonly router: Router) {
    }

    ngOnInit(): void {
        if (this.defaultHref === undefined) {
            this.defaultHref = this.router.url;
        }
    }
}
